import {type AxiosResponse} from "axios";
import {isSuccess} from "../../infrastructure/http-status";
import {errorUserMessage} from "./actions";
import {displayUserMessage} from "./messagesSlice";
import {type ThunkDispatch} from "redux-thunk";
import {type ApiResponse} from "../../infrastructure/types";

export const showUserMessages = <T>(
  response: AxiosResponse<ApiResponse<T>>,
  dispatch: ThunkDispatch<any, any, any>
) => {
  !isSuccess(response.status) &&
    response.data?.messages.userMessages.forEach(userMessage =>
      dispatch(displayUserMessage(errorUserMessage(userMessage).payload))
    );
};
